import { render } from "./BlockItem.vue?vue&type=template&id=3a71d44c"
import script from "./BlockItem.vue?vue&type=script&lang=js"
export * from "./BlockItem.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__